import {Directive, ElementRef, Input} from "@angular/core";

@Directive({
  selector: '[appAutoFocus]'
})
export class AutofocusDirective {

  constructor(private el: ElementRef) {  }

  @Input() set focus(focus: boolean) {
    if(focus) {
      setTimeout( () => {this.el.nativeElement.focus()}, 100);
    }
  }

}
